// error notification handler
export const msgError = (msg, messageApi) => {
  messageApi.open({
    type: "error",
    content: msg,
  });
};

// success notification handler
export const msgSuccess = (msg, messageApi) => {
  messageApi.open({
    type: "success",
    content: msg,
  });
};

export const msgWarn = (msg, messageApi) => {
  messageApi.open({
    type: "warning",
    content: msg
  })
}

export const msgLoading = (msg, messageApi) => {
  messageApi.open({
    type: 'loading',
    content: msg,
    duration: 0,
  })
}
